import React from "react";
import { LocalAdventure } from "../../../entities/adventures/Adventure"
import { BreakdownWindow } from "../../theming/breakdown-window";
import { ThemedButton } from "../../inputs/buttons/ThemedButton";
import { AdventureActions } from "../../../store/stores/adventures/AdventureStore.Actions";
import { CharacterInitializer } from "../../../entities/characters/Character";
import { useAppDispatch, useAppSelector } from "../../../store/configureStore";
import { Link } from "react-router-dom";

type Props = {
    adventure: LocalAdventure;
    onClose: () => unknown;
}

export const AddCharacterMenu = (props: Props) => {
    const { adventure, onClose } = props;
    const dispatch = useAppDispatch();
    const {adventures} = useAppSelector(app => app.adventure);
    const {characters} = useAppSelector(app => app.character);
    const addCharacterToAdventure = (character: CharacterInitializer) => {
        dispatch(AdventureActions.addCharacterToAdventure(adventure, character));
        onClose();
    }
    const charactersAssignedToAdventures = adventures.mapMany(adventure => adventure.characterIds);
    return (
        <BreakdownWindow close={onClose} heading={<h1>Your Characters</h1>}>
            {!characters.any() && (<div>
                Looks like you don't have any characters yet, but you can create a character through the link below:
            </div>)}
            <Link to="/Characters/Create"><ThemedButton disabled={false}>Create a New Character</ThemedButton></Link>
            {characters.map(character => {
                const alreadyAssigned = charactersAssignedToAdventures.contains(character.id);
                return (
                    <div key={character.id} className={`${alreadyAssigned ? '' : 'disabled'}`}>
                        {character.name} <ThemedButton disabled={alreadyAssigned} onClick={() => addCharacterToAdventure(character)}>Add To Adventure</ThemedButton>
                    </div>
                );
            })}
        </BreakdownWindow>
    );
}